import { user as User } from "@fas/ui-framework";

// eslint-disable-next-line import/prefer-default-export
export const userService: User = new User();
export default userService;
